"use strict";

exports.wrapPageElement = require('./lib/browser/wrapPageElement').default;